module.exports = __webpack_public_path__ + "static/timetravel_logo-b931edc5ecd4398084c52b5c05159054.jpg";